import React, { Component } from 'react'
import { Redirect, Link } from 'react-router-dom'
import NavBar from '../components/navbar'
import Footer from '../components/footer'
import Loading from '../components/loading'
import LandingSideInfo from '../components/landingSideInfo'
import LandingLowerInfo from '../components/landingLowerInfo'
import { connect } from 'react-redux'
import immunizationIcon from '../images/immunization-icon.png';
import resultsIcon from '../images/covidresults-icon.png';
import { fetchDemographicsThunk, setErrorState } from '../actions/api'
import { setLoggingIn } from '../actions/auth'

class HomePage extends Component {

    componentDidMount() {
        this.props.dispatch(fetchDemographicsThunk())
            .catch(err => {
                if (err !== null && err !== undefined) {
                    if (err.code === 'IUE') {
                        this.props.dispatch(setErrorState(true, err.message, true));
                    } else if(err.code === 'MIE'){
                        this.props.dispatch(setErrorState(true, err.message, true));
                    } else {
                        this.props.dispatch(setErrorState(true, err.message, true));
                    }
                }
            });;
    }

    render() {
        if (this.props.isError === true) {
            return <Redirect to="error" />
        }
        // FIXME Remove fake login!!!
        if (this.props.isLoggedIn !== true && this.props.isFakeLoggedIn !== true) {
            return <Redirect to="/" />
        }
        if (this.props.isLoadingLogin === true || this.props.isLoadingLabResults === true || !this.props.user) {
            return <Loading />
        }

        return (
            <div className="container-full">
                <NavBar isLoggedIn={this.props.isLoggedIn} language={this.props.language} />
                <div className="container topPadding">
                    <div class="col">
                        <div class="row wBorder">
                            <LandingSideInfo />
                            <div className="col-12 col-md-8 order-1 order-sm-1 order-md-1 ml-auto ml-md-auto noMargin">
                                <div className="titleBox">
                                    <h4>{this.props.strings.LANDING_HEADING}</h4>
                                </div>
                                <div className="catBox">
                                    <div className="row" style={{ textAlign: 'center' }}>
                                        <div className="col-12 col-md-6">
                                            <div className="catItem1">
                                                <Link to="results">
                                                    <img src={resultsIcon} className="catIMG" />
                                                    <br /><br />
                                                    {this.props.strings.LANDING_TEST_RESULTS}
                                                </Link>
                                            </div>
                                        </div>
                                        <div className="col-12 col-md-6">
                                            <div className="catItem2">
                                                <Link to="immunizations">
                                                    <img src={immunizationIcon} className="catIMG" />
                                                    <br /><br />
                                                    {this.props.strings.LANDING_IMMUNIZATIONS}
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <LandingLowerInfo />
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        user: state.api.user,
        strings: state.language.strings,
        language: state.language.language,
        isLoggedIn: state.auth.isLoggedIn,
        isLoadingLogin: state.auth.isLoadingLogin,
        isFakeLoggedIn: state.auth.isFakeLoggedIn,
        isLoadingLabResults: state.api.isLoadingLabResults,
        isLoadingUsers: state.api.isLoadingUsers,
        isError: state.api.isError,
        deviceType: state.api.deviceType,
    }
}

const ConnectedHomePage = connect(
    mapStateToProps
)(HomePage);
export default ConnectedHomePage;
